import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import One from "../../images/product/one.png";
import Two from "../../images/product/two.png";
import Three from "../../images/product/three.png";
import Four from "../../images/product/four.png";
import Five from "../../images/product/five.png";
const title_color = "#0071BA";

const Product = () => {
  const smallScreen1064 = useMediaQuery("(min-width:1064px)");

  return (
    <Box
      display={"flex"}
      gap={6}
      flexDirection={"column"}
      sx={{
        width: smallScreen1064 ? "1060px" : "100vw",
        margin: "0 auto",
        padding: "1.5rem",
        textWrap: "wrap",
      }}
    >
      {/* About Rawdat.AI Section */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Box sx={{ marginTop: "56px" }}></Box>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          About Rawdat.AI
        </Typography>
        <Typography variant="body1">
          Rawdat.AI offers limitless sky computing services for developers to
          publish applications with high speed and minimal friction. Using the
          platform, developers compose applications in real-time with no cloud
          infrastructure, only sky. With limitless sky computing, everything is
          abstraction except for the source code (business logic) of the
          application. Developers alone continuously integrate and deliver
          applications.
        </Typography>
        <Typography variant="body1">
          Developers can compose Go and Python applications. In near future
          releases of the platform, developers will be able to compose Java,
          NodeJS, and Web Assembly applications.
        </Typography>
      </Box>

      {/* Getting Started Section */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          Getting Started
        </Typography>
        <img src={One} alt="Getting Started" />
        <Typography variant="body1">
          Once logged in, you will be greeted by the platform to start creating
          applications.
        </Typography>
      </Box>

      {/* Composing Applications Section */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography
          variant="subtitle"
          sx={{ fontSize: "24px", color: title_color }}
        >
          Composing Applications
        </Typography>

        <Typography variant="body1">
          Once directed to the Create page, you can start entering the required
          fields to deploy the application:
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          <Typography component="li" variant="body1">
            Language; You can chose between Go, Python, or Web server for static
            content delivery
          </Typography>
          <Typography component="li" variant="body1">
            Function Name; Label your application with a name
          </Typography>
          <Typography component="li" variant="body1">
            Code; The source code of the application. By default, the code
            returns a simple Hello World message
          </Typography>
          <Typography component="li" variant="body1">
            Path URI; The Uniform Resource Identifier used to retrieve the
            application
          </Typography>
          <Typography component="li" variant="body1">
            Protocol and hostname; Select HTTP or HTTPS. The hostname is
            optional for HTTP applications
          </Typography>
          <img
            style={{ width: "98%" }}
            src={Two}
            alt="Composing Applications"
          />
        </Box>
        <Typography variant="body1">
          Once the application is deployed, it will show in the Deployment page
          with an assigned VIP (Virtual IP) to retrieve it.
        </Typography>
        <img style={{ width: "98%" }} src={Three} alt="Deployed Applications" />
        <Typography variant="body1">
          Developers will have one VIP to retrieve all applications inside one
          account. Use the VIP and path URI to retrieve the application.
        </Typography>
        <img
          style={{ width: "98%" }}
          src={Four}
          alt="Retrieving Applications"
        />
      </Box>

      {/* HTTPS Applications Section */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography
          variant="subtitle"
          sx={{ fontSize: "24px", color: title_color }}
        >
          Composing HTTPS Applications
        </Typography>
        <Typography variant="body1">
          The means to composing HTTPS applications is almost identical to
          composing HTTP applications. Developers only set the protocol to HTTPS
          and use a hostname resolving to the VIP assigned to the account.
        </Typography>
        <Typography variant="body1">
          Once the HTTPS the application is deployed, TLS cert/keys auto
          generate and can be reused indefinitely with other applications. The
          auto generated cert/keys can be found in the Deployments page.
        </Typography>
      </Box>

      {/* Resources Section */}
      {/* <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          Resources
        </Typography>
        <Typography variant="body1">
          Deploying Functions with Rawdat.AI – Demo Video{" "}
          <Box component="span" sx={{ color: "#888" }}>
            (link to YouTube video TBD)
          </Box>
        </Typography>
      </Box> */}

      {/* Next Steps Section */}
      <img style={{ width: "98%" }} src={Five} alt="Next Steps" />
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          Next Steps
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          <Typography component="li" variant="body1">
            Get started with a{" "}
            <a
              href="/subscribe"
              style={{ textDecoration: "none", color: title_color }}
            >
              7-day free trial
            </a>
          </Typography>
          <Typography component="li" variant="body1">
            Contact us at{" "}
            <a
              href="mailto:support@rawdat.ai"
              style={{ textDecoration: "none", color: title_color }}
            >
              support@rawdat.ai
            </a>
          </Typography>
        </Box>
      </Box>

      <Box sx={{ marginBottom: "50px" }}></Box>
    </Box>
  );
};

export default Product;
